import React from 'react'

import FilterList from './FilterList'

const Currency = ({
  state, accounts, top_accounts, setCryptoCurrency, blank_modal_src,
  widget_instance_token,
}) => {
  const handleCryptoCurrencyChange = e => setCryptoCurrency(e.target.value)

  const optionProps = {
    className: 'btn rounded-circle ratio ratio-1x1 p-0 btn-light btn-check-special',
    style: { width: '4rem', maxWidth: 'calc((100vw - 4rem) / 5)' },
  }

  const optionInnerProps = {
    className: 'd-flex flex-column justify-content-center',
    style: { lineHeight: 1 },
  }

  return (
    <div
      className="d-flex flex-wrap justify-content-center mx-n1 mb-n2"
      role="group"
      aria-label="Cryptocurrencies"
    >
      {top_accounts.map(account => {
        const id        = `cryptoCurrencyTopOption${account.currency}`
        const selected  = account.currency == state.crypto_currency

        return (
          <div className="position-relative px-1" key={account.currency}>
            <input
              type="radio"
              className="btn-check"
              id={id}
              name="cryptoCurrency"
              checked={selected}
              value={account.currency}
              onChange={handleCryptoCurrencyChange}
            />
            <label {...optionProps} htmlFor={id}>
              <span {...optionInnerProps}>
                <span>
                  <img src={account.icon} style={{ width: '1.5em', height: '1.5em' }} />
                  <br /><small>{account.currency}</small>
                </span>
              </span>
            </label>
          </div>
        )
      })}
      <div className="px-1">
        <input
          type="radio"
          className="btn-check"
          checked={!top_accounts.find(a => a.currency == state.crypto_currency)}
          readOnly
          tabIndex={-1}
        />
        <FilterList
          id={`cryptoCurrency:${widget_instance_token}`}
          title="Cryptocurrencies"
          value={state.crypto_currency}
          onChange={setCryptoCurrency}
          blank_modal_src={blank_modal_src}
          options={accounts.map(account => ({
            label: account.name,
            value: account.currency,
          }))}
          render={({ open }) => (
            <button {...optionProps} type="button" onClick={open}>
              <small {...optionInnerProps}>Other<br />Coins</small>
            </button>
          )}
        />
      </div>
    </div>
  )
}

export default Currency
